export type ReasoningPreference = 'normal' | 'high' | 'max';
export type ModelReasoningEffort = 'none' | 'low' | 'medium' | 'high' | 'xhigh' | 'max';

export function normalizeReasoningPreference(value: unknown): ReasoningPreference {
  return value === 'high' || value === 'max' ? value : 'normal';
}

export function canUseReasoningPreference(preference: ReasoningPreference, tier: string) {
  return preference === 'normal' || tier === 'admin' || tier === 'premium'
    || (preference === 'high' && tier === 'professional');
}

export function getAuthorizedReasoningPreference(value: unknown, tier: string): ReasoningPreference {
  const preference = normalizeReasoningPreference(value);
  return canUseReasoningPreference(preference, tier) ? preference : 'normal';
}

/** Move from the evaluated baseline through the model's supported levels. */
export function resolveReasoningEffort(
  model: string, baseline: ModelReasoningEffort, preference: ReasoningPreference = 'normal'
): ModelReasoningEffort {
  const supportsNone = /^(gpt-6-luna|gpt-6-sol)(?:-\d{4}-\d{2}-\d{2})?$/.test(model);
  const minimumLow = /^(gpt-6\.1-sol|gpt-6-astra)(?:-\d{4}-\d{2}-\d{2})?$/.test(model);
  if (!supportsNone && !minimumLow) throw new Error('juris_reasoning_model_unsupported');
  const levels: ModelReasoningEffort[] = minimumLow ? ['low', 'medium', 'high', 'xhigh', 'max']
    : ['none', 'low', 'medium', 'high', 'xhigh', 'max'];
  const index = levels.indexOf(baseline);
  if (index < 0) throw new Error('juris_reasoning_baseline_unsupported');
  const increment = preference === 'max' ? 2 : preference === 'high' ? 1 : 0;
  if (index + increment >= levels.length) throw new Error('juris_reasoning_preference_unsupported');
  return levels[index + increment];
}
